"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggingAPICall = void 0;
const env_config_1 = __importDefault(require("../../../env.config"));
const LoggingAPICall = (body) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const LOGGING_URL_CLIENT = env_config_1.default === null || env_config_1.default === void 0 ? void 0 : env_config_1.default.LOGGING_URL_CLIENT;
        const LOGGING_SERVER_KEY = env_config_1.default === null || env_config_1.default === void 0 ? void 0 : env_config_1.default.LOGGING_SERVER_KEY;
        const url = LOGGING_URL_CLIENT;
        const headers = {
            'Content-Type': 'application/json',
            'X-Auth-Token': LOGGING_SERVER_KEY
        };
        const response = yield fetch(url, {
            method: 'POST',
            body: JSON.stringify(body),
            headers
        });
        if (!response.ok) {
            console.error(`HTTP error! Status: ${response.status}`);
        }
        return yield response.json();
    }
    catch (error) {
        console.error(error);
        throw error;
    }
});
exports.LoggingAPICall = LoggingAPICall;
